import { isValidHttpUrl } from './link-utils';

export const getVirtualHost = (req: any) => {
  let host = getHost(req);

  if (process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST && process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST !== '') {
    const devUrl = new URL(
      process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST,
      !isValidHttpUrl(process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST) ? 'http://fake-base.com' : undefined,
    );
    host = devUrl.host;
  } else if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST === '') {
    host = 'uat.testing-stylus.com';
  }
  return host;
};

export const getHost = (req: any) => {
  let host = null;
  if (req.headers.get) {
    host = req.headers.get('x-forwarded-host') || req.headers.get('x-host') || req.headers.get('host');
  } else {
    host = req.headers['x-forwarded-host'] || req.headers['x-host'] || req.headers['host'];
  }
  if (host && host.includes(',')) {
    host = host.split(',').pop();
  }
  return host;
};

export const getProtocol = (req: any) => {
  const isDevEnv = getHost(req).endsWith(':3000');
  if (req.headers.get) {
    return (req.headers.get('x-forwarded-proto') || (isDevEnv ? 'http' : 'https')) + ':';
  }
  return (req.headers['x-forwarded-proto'] || (isDevEnv ? 'http' : 'https')) + ':';
};

export const getVirtualIP = (req: any) => {
  let ip = getIP(req);
  if (process.env.DEV_CLIENT_IP && process.env.DEV_CLIENT_IP !== '') {
    ip = process.env.DEV_CLIENT_IP;
  } else if (process.env.NODE_ENV === 'development' && !process.env.DEV_CLIENT_IP) {
    ip = '127.0.0.1';
  }
  return ip;
};

export const getIP = (req: any) => {
  let ip = null;
  if (req.headers.get) {
    ip =
      req.headers.get('client-ip') ||
      req.headers.get('x-forwarded-for') ||
      req.headers.get('x-real-ip') ||
      req.headers.get('X-Client-IP');
  } else {
    ip =
      req.headers['client-ip'] ||
      req.headers['x-forwarded-for'] ||
      req.headers['x-real-ip'] ||
      req.headers['X-Client-IP'];
  }
  if (ip && ip.includes(',')) {
    ip = ip.split(',').pop().trim();
  }
  return ip;
};
